(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mc-v-image"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    var nodes = root.querySelectorAll('[data-mc-carousel]');
    for(var i=0;i<nodes.length;i++){
      var carousel=nodes[i];
      if(carousel.dataset.mcReady==='true') continue;
      var track=carousel.querySelector('[data-mc-carousel-track]');
      var controls=carousel.querySelector('[data-mc-carousel-controls]');
      if(!track||!controls) continue;
      var slides=Array.prototype.filter.call(track.children,function(el){return el.classList.contains('shopify-block')&&!el.hidden});
      if(!slides.length) continue;
      carousel.dataset.mcReady='true';
      carousel.classList.add('is-ready');
      if(slides.length<2) continue;
      controls.hidden=false;
      setup(carousel,track,slides,controls);
    }
  }
  function setup(carousel,track,slides,controls){
    var index=0;
    var count=controls.querySelector('[data-mc-carousel-count]');
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    var interval=parseInt(carousel.dataset.interval,10)||5000;
    var timer;
    var paused=false;
    var visible=true;
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;},{threshold:0.1});
      observer.observe(carousel);
    }
    function update(){index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));count.textContent=(index+1)+' / '+slides.length;}
    function go(next){index=(next+slides.length)%slides.length;track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced.matches?'auto':'smooth'});count.textContent=(index+1)+' / '+slides.length;}
    controls.querySelector('[data-mc-carousel-prev]').addEventListener('click',function(){go(index-1)});
    controls.querySelector('[data-mc-carousel-next]').addEventListener('click',function(){go(index+1)});
    track.addEventListener('scroll',update,{passive:true});
    carousel.addEventListener('mouseenter',function(){paused=true});
    carousel.addEventListener('mouseleave',function(){paused=false});
    carousel.addEventListener('focusin',function(){paused=true});
    carousel.addEventListener('focusout',function(){paused=false});
    if(carousel.dataset.autoplay==='true'&&!reduced.matches&&!(window.Shopify&&window.Shopify.designMode)){
      timer=window.setInterval(function(){
        if(!document.contains(carousel)){window.clearInterval(timer);return;}
        if(!paused&&visible&&!document.hidden) go(index+1);
      },Math.max(3000,interval));
    }
    update();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document)}); else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
  } catch(e) { console.error(e); }
})();

})();
